import axios from 'axios'
import { log } from "@/composables/useLog"
import { BASE_URL } from "@/composables/url_config"

export const getClientsList = async (token, options = {}) => {
  log("welcome in getClientsList")
  const API_URL = `${BASE_URL}/home/get_clients_list_api`

  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }

    const params = {
      search_term: options.search_term || '',
      parent_client_id: options.parent_client_id || '',
      client_id: options.client_id || '',
      include_subclients: options.include_subclients || false,
      status_ids: options.status_ids || [],
      client_type_id: options.client_type_id || 'all',
      billing_type_id: options.billing_type_id || 'all',
      show_deleted: options.show_deleted || 'active',
      sort_by: options.sort_by || 'name',
      sort_order: options.sort_order || 'asc',
      page: options.page || 1,
      per_page: options.per_page || 20
    }

    const result = await axios.get(API_URL, { headers, params })
    log("getClientsList result:")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in getClientsList:")
    log(err)
    return { error: true, message: err.message }
  }
}

export const approveClient = async (token, clientId) => {
  log("welcome in approveClient")
  const API_URL = `${BASE_URL}/home/approve_client_api`

  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }

    const data = {
      client_id: clientId
    }

    const result = await axios.post(API_URL, data, { headers })
    log("approveClient result:")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in approveClient:")
    log(err)
    return { error: true, message: err.message }
  }
}

export const limitClient = async (token, clientId) => {
  log("welcome in limitClient")
  const API_URL = `${BASE_URL}/home/limit_client_api`

  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }

    const data = {
      client_id: clientId
    }

    const result = await axios.post(API_URL, data, { headers })
    log("limitClient result:")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in limitClient:")
    log(err)
    return { error: true, message: err.message }
  }
}

export const suspendClient = async (token, clientId) => {
  log("welcome in suspendClient")
  const API_URL = `${BASE_URL}/home/suspend_client_api`

  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }

    const data = {
      client_id: clientId
    }

    const result = await axios.post(API_URL, data, { headers })
    log("suspendClient result:")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in suspendClient:")
    log(err)
    return { error: true, message: err.message }
  }
}

export const deleteClient = async (token, clientId, reason) => {
  log("welcome in deleteClient")
  const API_URL = `${BASE_URL}/home/delete_client_api`

  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }

    const data = {
      client_id: clientId,
      reason: reason || ''
    }

    const result = await axios.post(API_URL, data, { headers })
    log("deleteClient result:")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in deleteClient:")
    log(err)
    return { error: true, message: err.message }
  }
}

export const unblockClient = async (token, clientId) => {
  log("welcome in unblockClient")
  const API_URL = `${BASE_URL}/home/unblock_client_api`

  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }

    const data = {
      client_id: clientId
    }

    const result = await axios.post(API_URL, data, { headers })
    log("unblockClient result:")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in unblockClient:")
    log(err)
    return { error: true, message: err.message }
  }
}

export const blockClient = async (token, clientId) => {
  log("welcome in blockClient")
  const API_URL = `${BASE_URL}/home/block_client_api`

  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }

    const data = {
      client_id: clientId
    }

    const result = await axios.post(API_URL, data, { headers })
    log("blockClient result:")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in blockClient:")
    log(err)
    return { error: true, message: err.message }
  }
}

export const reactivateClient = async (token, clientId) => {
  log("welcome in reactivateClient")
  const API_URL = `${BASE_URL}/home/reactivate_client_api`

  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }

    const data = {
      client_id: clientId
    }

    const result = await axios.post(API_URL, data, { headers })
    log("reactivateClient result:")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in reactivateClient:")
    log(err)
    return { error: true, message: err.message }
  }
}

export default { getClientsList, approveClient, limitClient, suspendClient, deleteClient, unblockClient, blockClient, reactivateClient }
